import React from "react";
import "./styles/gallery.css";

import g1 from "../images/g1.jpg";
import g2 from "../images/g2.jpg";
import g3 from "../images/g3.jpg";
import g4 from "../images/g4.jpg";
import g5 from "../images/g5.jpg";
import g6 from "../images/g6.jpg";
import g7 from "../images/g7.jpg";
import g8 from "../images/g8.jpg";
import g9 from "../images/g9.jpg";
import g10 from "../images/g10.jpg";
import g11 from "../images/g11.jpg";
import g12 from "../images/g12.jpg";
import g13 from "../images/g13.jpg";
import g14 from "../images/g14.jpg";
import g15 from "../images/g15.jpg";
import g16 from "../images/g16.jpg";
import g17 from "../images/g17.jpg";
import g18 from "../images/g18.jpg";


const images = [
  g1,
  g2,
  g3,
  g4,
  g5,
  g6,
  g7,
  g8,
  g9,
  g10,
  g11,
  g12,
  g13,
  g14,
  g15,
  g16,
  g17,
  g18,
 
];

const Gallery = () => {
  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Our Gallery</h1>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item">
            <img src={image} alt={`Gallery Image ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
